import Vue from 'vue'
let AuthImage = require('@/directives/auth-image-directive.js')

Vue.use(AuthImage)
